var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61537 22C7.15512 22 6.77083 21.8458 6.4625 21.5375C6.15417 21.2292 6 20.8449 6 20.3846V3.61537C6 3.15512 6.15417 2.77083 6.4625 2.4625C6.77083 2.15417 7.15512 2 7.61537 2H14.0769V3H7.61537C7.46154 3 7.32052 3.0641 7.1923 3.1923C7.0641 3.32052 7 3.46154 7 3.61537V4.5H14.0769V5.5H7V18.5H17V16.5H18V20.3846C18 20.8449 17.8458 21.2292 17.5375 21.5375C17.2292 21.8458 16.8449 22 16.3846 22H7.61537ZM7 19.5V20.3846C7 20.5385 7.0641 20.6795 7.1923 20.8077C7.32052 20.9359 7.46154 21 7.61537 21H16.3846C16.5385 21 16.6795 20.9359 16.8077 20.8077C16.9359 20.6795 17 20.5385 17 20.3846V19.5H7ZM18 13.2885L13.6923 8.98078L14.4 8.27307L17.5 11.3731V3.5H18.5V11.3731L21.6 8.27307L22.3077 8.98078L18 13.2885Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAppIcon);
export default __webpack_public_path__ + "static/media/download-app-icon.9c7dd01b2922bb3d3e0513c9c02e2453.svg";
export { ForwardRef as ReactComponent };